// @ts-expect-error No type for Bend URL
import hubspotMobileApp from 'bender-url!../../img/hubspotMobileApp.png';
// @ts-expect-error No type for Bend URL
import passkeyLogo from 'bender-url!../../img/passkey-logo.svg';
export default {
  hubspotMobileApp,
  passkeyLogo
};